export default "__VITE_ASSET__ByYq$xXm__"